import { Icon } from '../index';
import { Icons } from '../Icon/Icon';
import styles from './ToggleIcon.module.css';

const ToggleIcon = ({
    isActive,
    onClick,
    type = 'primary',
}: {
    isActive?: boolean;
    onClick?: any;
    type?: 'primary' | 'secondary';
}) => {
    const icon = type === 'secondary' ? Icons.chevronDown : Icons.chevronDownFilled;
    return (
        <span
            className={`${styles.toggle} ${styles[type]} ${isActive ? styles.active : ''}`}
            onClick={onClick}
        >
            <Icon icon={icon} />
        </span>
    );
};

export default ToggleIcon;
